var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-email-endings"},[_c('div',{staticClass:"company-email-endings-list"},[_vm._l((_vm.getUObjects({type: 'bemails', ids: _vm.business.bemails})),function(bemail){return _c('div',{key:bemail.id,staticClass:"company-email-endings-list-entry",on:{"click":function($event){return _vm.$router.push({
        name: 'CompanyEmailEndingsDetails',
        params: {
          email_endings_id: bemail.id
        }
        })}}},[_vm._v(" @"+_vm._s(bemail.value)+" ")])}),_c('div',{staticClass:"company-email-endings-add-btn green",attrs:{"color":"green"},on:{"click":function($event){return _vm.$router.push({
      name: 'CompanyEmailEndingsCreate',
      })}}},[_c('v-icon',[_vm._v("add")]),_vm._v("add mail ending ")],1)],2),_c('div',{staticClass:"company-email-endings-details"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }